import { matchUrlExact } from '@atlassian/jira-navigation-apps-sidebar-common/src/utils/url-matchers/index.tsx';
import type { MatcherLocation } from '@atlassian/jira-navigation-apps-sidebar-common/src/utils/url-matchers/types.tsx';

const PROJECT_ROLES_PATH_REGEXP = /\/project\/(\w+)ProjectRole/i;

export const isProjectRolesSelected = (
	currentLocation: MatcherLocation,
	itemLocation: MatcherLocation,
): boolean =>
	matchUrlExact()(currentLocation, itemLocation) ||
	PROJECT_ROLES_PATH_REGEXP.test(currentLocation.pathname);
